import { TravellerFieldEnum } from '@websky/graphql';
import { User } from './types';

export const getExistUserType = (user: User, type: TravellerFieldEnum) => {
	if (!user.values?.length) {
		return false;
	}

	return user.values.some(value => value.type === type);
};
